var map = {
	"./breadcrumbs.scss": [
		5183,
		[
			1140
		]
	],
	"./site-footer-block.scss": [
		1996,
		[
			6791
		]
	],
	"./site-header-block.scss": [
		1054,
		[
			3781
		]
	],
	"./test-cta.scss": [
		6451,
		[
			6395
		]
	],
	"./test-icons-block.scss": [
		9615,
		[
			7303
		]
	],
	"./test-theme-block.scss": [
		8155,
		[
			2736
		]
	],
	"./test-typography-block.scss": [
		9259,
		[
			6432
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(function() {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(function() { return __webpack_require__.t(id, 1 | 16); });
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 6071;
module.exports = webpackAsyncContext;